<script>
  import { Size } from "./enums";
  import Icon from "./Icon/Icon.svelte";
  import { Icons } from "./Icon/Icons";
  import Select from "./Select.svelte";

  export let title;
  export let value;
  export let change = null;
  export let selectValue = null;
  export let selectOptions = null;

  $: changeColorClasses = (change ?? 0) > 0 ? "text-[#0F9F4F] bg-[#E1FFEE]" : "text-[#EE5D5D] bg-[#FFE7E7]";

  $: changeBadgeClasses = `ml-2 flex items-center text-xs px-1 py-0.5 rounded-[4px] ${changeColorClasses}`;
</script>

<div class="border-neutral-400 border rounded-lg px-4 py-3 w-full md:w-[250px]">
  <div class="flex items-center justify-between">
    <div class="text-xs font-normal text-neutral-900 whitespace-nowrap">
      {title}
    </div>
    {#if selectOptions != null}
      <Select bind:value={selectValue} options={selectOptions} label="" size={Size.Small} border={false} />
    {/if}
  </div>
  <div class="flex mt-0.5">
    <div class="text-sm font-semibold text-neutral-1100">
      {value}
    </div>
    {#if change != null}
      <div class={changeBadgeClasses}>
        <Icon iconType={Icons.Arrow} size={Size.Small} pathFill={(change ?? 0) > 0 ? "#0F9F4F" : "#EE5D5D"} class={(change ?? 0) > 0 ? "rotate-180" : "rotate-0"} />
        {Math.abs(change)}%
      </div>
    {/if}
  </div>
  
</div>
